import { render, staticRenderFns } from "./PageNewsCreate.vue?vue&type=template&id=491ca02c&"
import script from "./PageNewsCreate.vue?vue&type=script&lang=js&"
export * from "./PageNewsCreate.vue?vue&type=script&lang=js&"
import style0 from "./PageNewsCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports